import { render, staticRenderFns } from "./MyDetails.vue?vue&type=template&id=445e516e&scoped=true&"
import script from "./MyDetails.vue?vue&type=script&lang=js&"
export * from "./MyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e516e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445e516e')) {
      api.createRecord('445e516e', component.options)
    } else {
      api.reload('445e516e', component.options)
    }
    module.hot.accept("./MyDetails.vue?vue&type=template&id=445e516e&scoped=true&", function () {
      api.rerender('445e516e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/Profile/MyDetails.vue"
export default component.exports